module.exports = __webpack_public_path__ + "img/banner-11.921947e4.jpg";